import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-register-modal',
  templateUrl: './register-modal.component.html',
  styleUrls: ['./register-modal.component.css'],
})
export class RegisterModalComponent implements OnInit {
  datas;
  /**
   * Component constructor.
   * @param data Dialog data.
   * @param dialogRef Dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RegisterModalComponent>
  ) {
    /**
     * The dialog data that has been passed to the component.
     */
    this.datas = data;
  }

  /**
   * Lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * This is the best place to put initialization code.
   * We call the checkRegistrationStatus and checkRegistrationStatusCoE to set the flags
   * for registration status
   */
  ngOnInit(): void {
    this.checkRegistrationStatus();
    this.checkRegistrationStatusCoE();
  }
  /**
   * Closes the registration modal dialog.
   * This function is typically invoked when the user completes or cancels the registration process.
   */
  modalClose() {
    // Close the dialog
    this.dialogRef.close();
  }
  isRegistrationClosedPre: boolean = false;
  /**
   * Checks if the registration for incubation is closed
   * @description Checks if the current date is after the registration deadline for incubation
   */
  checkRegistrationStatus() {
    // Deadline for registration for incubation
    // const deadline = new Date(2025, 1, 14, 12, 40); // February 14, 2025, at 12:35 PM
    const deadline = new Date(2026, 2, 31, 23, 59, 0); // March 7, 2025, 5:01 PM
    const now = new Date();

    // Set the isRegistrationClosed flag based on the comparison
    this.isRegistrationClosedPre = now >= deadline;
  }
  isRegistrationClosedCoE: boolean = false;
  /**
   * Checks if the registration for CoE is closed
   * @description Checks if the current date is after the registration deadline for CoE
   */
  checkRegistrationStatusCoE() {
    // 2nd March 2026, 12:00 AM
    const deadline = new Date(2026, 2, 4, 11, 30, 0);
    const now = new Date();

    // If the current date is after the deadline, then the registration is closed
    this.isRegistrationClosedCoE = now >= deadline;
  }
}
